import { Message, Notification, MessageBox } from 'element-ui'
export default ({
    // 将时间转成时间戳(13位)
    formatTimestamp (time) {
        let date = ''
        if (time) {
            date = new Date(time)
        } else {
            date = new Date()
        }
        return date.getTime()
    },
    // 将时间戳转换成时间格式
    formatDate (timestamp, gap, hastime) {
        if (!timestamp) {
            return '--'
        }
        var date = new Date()
        date.setTime(timestamp)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        var d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        var h = date.getHours()
        h = h < 10 ? ('0' + h) : h
        var minute = date.getMinutes()
        var second = date.getSeconds()
        minute = minute < 10 ? ('0' + minute) : minute
        second = second < 10 ? ('0' + second) : second
        let gapstr = '-'
        let timestr = ''
        // 日期分隔符
        if (gap) {
            gapstr = gap
        }
        // 是否有时分秒
        if (hastime) {
            timestr = ' ' + h + ':' + minute + ':' + second
        }
        return y + gapstr + m + gapstr + d + timestr
    },
    // 某个时间与当前时间对比
    contrastTime (time) {
        let date = new Date(time)
        let now = new Date()
        let nowStamp = now.getTime()
        let everydayStamp = 86400000 // 每一天的时间戳
        let dateStamp = date.getTime() + everydayStamp - 1000 // 交货日期的时间戳 （即到 23:59:59的时间）
        let dValue = nowStamp - dateStamp // 当前时间减去交货时间
        if (dValue < 0) { // 说明没有延期
            let D = -Math.ceil(Math.abs(dValue) / everydayStamp)
            return D
        } else if (dValue === 0) {
            return 0
        } else {
           return Math.ceil(dValue / everydayStamp)
        }
    },
    // 获取当前日期addDays之前或之后的天的日期
    getDateStr(addDays, gap, datetime) {
        var date = datetime ? new Date(datetime) : new Date()
        date.setDate(date.getDate() + addDays) // 获取addDays天后的日期，如果为负数则为之前addDays前的
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? ('0' + m) : m
        var d = date.getDate()
        d = d < 10 ? ('0' + d) : d
        let gapstr = gap || '-'
        return y + gapstr + m + gapstr + d
    },
    replaceStr(value, rep) { // 将空值转成 rap替换
        if (value === null || !value) {
            let repstr = '--'
            if (rep) {
                repstr = rep
            }
            return repstr
        } else {
            return value
        }
    },
    // 操作结果提示
    handleMessageTips(tipsObj) {
        Message({
            message: tipsObj ? (tipsObj.message ? tipsObj.message : '操作成功') : '操作成功',
            type: tipsObj ? (tipsObj.type ? tipsObj.type : 'success') : 'success',
            duration: tipsObj ? (tipsObj.duration ? tipsObj.duration : 3500) : 3500,
            onClose: function () {
                if (tipsObj) {
                    if (tipsObj.callback) {
                        tipsObj.callback()
                    }
                }
            }
        })
    },
    // notify提示框
    notifyTips(tipsObj) {
        Notification({
            title: tipsObj.title ? tipsObj.title : '提示',
            message: tipsObj.message,
            type: tipsObj.type ? tipsObj.type : '',
            duration: tipsObj.duration ? tipsObj.duration : 3000,
            onClose: tipsObj.callback ? tipsObj.callback : () => {}
        })
    },
    // 二次确认操作
    confirmTip (tipsObj, callback, catchback) {
        let title = tipsObj.title ? tipsObj.title : '提示'
        let message = tipsObj.message ? tipsObj.message : ''
        let type = tipsObj.type ? tipsObj.type : 'warning'
        MessageBox.confirm(message, title, {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: type
        }).then(() => {
            callback()
        }).catch(() => {
            if (catchback) {
                catchback()
            }
        })
    },
    // 判断元素是否在数组中存在
    isInArray(val, arr) {
        if (!Array.indexOf) {
            var A = Array
            A.prototype.indexOf = function(obj) {
                for (var i = 0; i < this.length; i++) {
                    if (this[i] === obj) {
                        return i
                    }
                }
                return -1
            }
        } else {
            return arr.indexOf(val)
        }
    },
    // 两个数组去重链接
    delRepConcat(arr1, arr2) {
        var arr = arr1.concat()
        for (var i = 0; i < arr2.length; i++) {
            arr.indexOf(arr2[i]) === -1 ? arr.push(arr2[i]) : 0
        }
        return arr
    },
    // 两个数组对比，如果arr1的元素在arr2中有，则从arr1去掉
    delArrayDiff(arr1, arr2) {
        if (arr2.length > 0) {
            for (var i = 0; i < arr2.length; i++) {
                for (var j = 0; j < arr1.length; j++) {
                    if (arr1[j] === arr2[i]) {
                        arr1.splice(j, 1)
                        j = j - 1
                    }
                }
            }
        }
        return arr1
    },
    // 获取对象指定的某个值
    getJsonValue(index, obj, v, l) {
        let val = v || 'value'
        let label = l || 'label'
        if (index) {
            for (let i in obj) {
                if (obj[i][val] === index) {
                    return obj[i][label]
                }
            }
        } else {
            return ''
        }
    },
    /* ===== 浮点型数据的加、减、乘、除 ===== */
    add(arg1, arg2) { // 加法
        let r1, r2, m
        try {
            r1 = arg1.toString().split('.')[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split('.')[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        return (arg1 * m + arg2 * m) / m
    },
    sub(arg1, arg2) { // 减法
        let r1, r2, m, n
        try {
            r1 = arg1.toString().split('.')[1].length
        } catch (e) {
            r1 = 0
        }
        try {
            r2 = arg2.toString().split('.')[1].length
        } catch (e) {
            r2 = 0
        }
        m = Math.pow(10, Math.max(r1, r2))
        n = (r1 >= r2) ? r1 : r2
        return ((arg1 * m - arg2 * m) / m).toFixed(n)
    },
    mul(arg1, arg2) { // 乘法
        let m = 0
        let s1 = arg1.toString()
        let s2 = arg2.toString()
        try {
            m += s1.split('.')[1].length
        } catch (e) {
        }
        try {
            m += s2.split('.')[1].length
        } catch (e) {
        }
        return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
    },
    div(arg1, arg2) { // 除法
        let t1 = 0
        let t2 = 0
        let r1
        let r2
        try {
            t1 = arg1.toString().split('.')[1].length
        } catch (e) {
        }
        try {
            t2 = arg2.toString().split('.')[1].length
        } catch (e) {
        }
        r1 = Number(arg1.toString().replace('.', ''))
        r2 = Number(arg2.toString().replace('.', ''))
        return (r1 / r2) * Math.pow(10, t2 - t1)
    },
    // JSON字符串转JSON
    turnJson(jsonstr) {
        return JSON.parse(JSON.stringify(jsonstr))
    },
    // 创建一个a标签用来下载文件
    downFile(url, download) {
        var a = document.createElement('a') // 创建一个<a></a>标签
        a.href = url // response is a blob
        a.download = download // 文件名称
        a.style.display = 'none'
        document.body.appendChild(a)
        a.click()
        a.remove()
    },
    // 设置cookie
    setCookie (name, value, expiredays) {
        var exdate = new Date()
        exdate.setTime(exdate.getTime() + expiredays * 60 * 1000)
        document.cookie = name + '=' + escape(value) + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString()) + ';path=/'
    },
    // 获取cookie
    getCookie(name) {
        if (document.cookie.length > 0) {
            let start = document.cookie.indexOf(name + '=')
            if (start !== -1) {
                start = start + name.length + 1
                let end = document.cookie.indexOf(';', start)
                if (end === -1) end = document.cookie.length
                return unescape(document.cookie.substring(start, end))
            }
        }
        return ''
    },
   isIphoneXFunc(){
      return /iphone/gi.test(navigator.userAgent) && (screen.height == 812 && screen.width == 375)
  }
})



// WEBPACK FOOTER //
// ./src/util/utils.js